export enum RoleFields {
  roleId = "roleId",
  name = "name",
  description = "description",

  createdAt = "createdAt",
  updatedAt = "updatedAt",
}
